interface ImageUploadIconProps {
  color?: string;
}

const ImageUploadIcon = ({
  color = "var(--text-icons-color-on-primary)",
}: ImageUploadIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={60}
      height={60}
      viewBox="0 0 60 60"
      style={{ color }}
      fill="none"
    >
      <g clipPath="url(#clip0_4295_35429)">
        <path
          d="M37.5 19.9999H37.525"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M31.25 52.5H15C13.0109 52.5 11.1032 51.7098 9.6967 50.3033C8.29018 48.8967 7.5 46.9891 7.5 45V15C7.5 13.0108 8.29018 11.1032 9.6967 9.69667C11.1032 8.29015 13.0109 7.49997 15 7.49997H45C46.9891 7.49997 48.8968 8.29015 50.3033 9.69667C51.7098 11.1032 52.5 13.0108 52.5 15V31.25"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.5 39.9998L20 27.4998C22.32 25.2673 25.18 25.2673 27.5 27.4998L36.25 36.2498"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M35 35L37.5 32.5C39.1975 30.8675 41.1825 30.4275 43.035 31.185"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M47.5 54.9999V39.9999"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M55 47.4999L47.5 39.9999L40 47.4999"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>

      <defs>
        <clipPath id="clip0_4295_35429">
          <rect width="60" height="60" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ImageUploadIcon;
